import { cn } from "@/lib/cn.ts";

/** A person's photo, or the first letter of their name on a tinted disc. */
export function UserAvatar({ name, image, size = "sm", className }: { name: string; image: string | null | undefined; size?: "xs" | "sm" | "md" | "lg"; className?: string }) {
  const dim = size === "xs" ? "size-5 text-[10px]" : size === "sm" ? "size-7 text-xs" : size === "lg" ? "size-16 text-2xl" : "size-10 text-base";
  if (image) return <img src={image} alt="" className={cn("shrink-0 rounded-full object-cover ring-1 ring-border", dim, className)} />;
  const initial = [...name.trim()][0]?.toUpperCase() ?? "?";
  return <span aria-hidden className={cn("grid shrink-0 place-items-center rounded-full bg-accent-soft font-semibold text-accent", dim, className)}>{initial}</span>;
}
